import { baseAPI } from "../../baseApi";
import { tagsTypes } from "../../tagsTypes";

export const authSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    postRegister: builder.mutation({
      query: (data) => ({
        url: "supplier-signup",
        method: "POST",
        body: data,
      }),
      // invalidatesTags: [tagsTypes.GET_USER_PROFILE],
    }),
    postLogin: builder.mutation({
      query: (data) => ({
        url: "supplier-login",
        method: "POST",
        body: data,
      }),
      // invalidatesTags: [tagsTypes.GET_USER_PROFILE],
    }),
    postForgotPassword: builder.mutation({
      query: (data) => ({
        url: "forget_password",
        method: "POST",
        body: data,
      }),
      // invalidatesTags: [tagsTypes.GET_USER_PROFILE],
    }),
    postVerifyOTP: builder.mutation({
      query: (data) => ({
        url: "supplier-email-verification",
        method: "POST",
        body: data,
      }),
      // invalidatesTags: [tagsTypes.GET_USER_PROFILE],
    }),
    postResetPassword: builder.mutation({
      query: (data) => ({
        url: "reset_password",
        method: "POST",
        body: data,
      }),
      // invalidatesTags: [tagsTypes.GET_USER_PROFILE],
    }),
    postResendOTP: builder.mutation({
      query: (data) => ({
        url: "supplier-resend-otp",
        method: "POST",
        body: data,
      }),
      // invalidatesTags: [tagsTypes.GET_USER_PROFILE],
    }),
    postVerifyUserProfile: builder.mutation({
      query: (token) => ({
        url: `verify-supplier/${token}`,
        method: "POST",
      }),
      
      invalidatesTags: [tagsTypes.GET_USER_PROFILE],
    }),
  }),
});

export const {
  usePostRegisterMutation,
  usePostLoginMutation,
  usePostForgotPasswordMutation,
  usePostVerifyOTPMutation,
  usePostResetPasswordMutation,
  usePostResendOTPMutation,
  usePostVerifyUserProfileMutation,
} = authSlice;
